import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useV1MarketplaceCatalogFamiliesCreate,
  useV1MarketplaceCatalogRevisionsCreate,
  useV1MarketplaceCatalogRevisionsPublishCreate,
} from "@/api/generated/v1/v1";
import { SourceTypeEnum } from "@/api/generated/models";
import { PageBanner } from "@/shared/components/PageBanner";

export function CatalogCreatePage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    code: "",
    internal_revision_id: "",
    title: "",
    description: "",
  });

  const { mutateAsync: createFamily } = useV1MarketplaceCatalogFamiliesCreate();
  const { mutateAsync: createRevision } = useV1MarketplaceCatalogRevisionsCreate();
  const { mutateAsync: publishRevision } = useV1MarketplaceCatalogRevisionsPublishCreate();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    try {
      // 1. Create Catalog Family
      const familyRes: any = await createFamily({ data: { code: formData.code } });
      const familyId = familyRes.id || familyRes.data?.id;
      
      // 2. Create Catalog Revision
      const revisionRes: any = await createRevision({
        data: {
          family: familyId,
          source_type: SourceTypeEnum.material_revision, // Defaulting for simplicity
          internal_revision_id: formData.internal_revision_id,
          title: formData.title,
          description: formData.description,
        },
      });
      const revisionId = revisionRes.id || revisionRes.data?.id;

      // 3. Publish Catalog Revision
      await publishRevision({ id: revisionId, data: {} as any });

      navigate("/marketplace/catalog");
    } catch (err: any) {
      console.error(err);
      setError("خطا در ایجاد کاتالوگ. لطفاً مقادیر را بررسی کنید.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="ایجاد کاتالوگ جدید"
        subtitle="با استفاده از این فرم، یک کاتالوگ جدید (Family + Revision) ایجاد و منتشر می‌شود."
        icon="📖"
        helpLink="/help/marketplace/catalog-create"
      />
      
      {error && <div style={{ color: "red", marginBottom: "16px" }}>{error}</div>}

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>کد کاتالوگ (Code)</label>
          <input
            className="input-field"
            name="code"
            value={formData.code}
            onChange={handleChange}
            required
            style={{ width: "100%" }}
          />
        </div>

        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>شناسه رفرنس داخلی (UUID مربوط به Material یا BOM)</label>
          <input
            className="input-field"
            name="internal_revision_id"
            value={formData.internal_revision_id}
            onChange={handleChange}
            required
            style={{ width: "100%" }}
          />
        </div>

        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>عنوان کاتالوگ</label>
          <input
            className="input-field"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            style={{ width: "100%" }}
          />
        </div>

        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>توضیحات</label>
          <textarea
            className="input-field"
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows={4}
            style={{ width: "100%" }}
          />
        </div>

        <button type="submit" disabled={isLoading} className="btn-primary" style={{ marginTop: "16px" }}>
          {isLoading ? "در حال ایجاد..." : "ایجاد و انتشار کاتالوگ"}
        </button>
      </form>
      </div>
    </div>
  );
}
